<template>
  <div class="wrapper">
    <template v-for="(rule, index) in rules">
      <RuleTypeShow
        :key="index"
        :rule="rule"
      />
    </template>
    <RuleAdd
      :rule-reference="ruleReference"
      :rule-type="ruleType.composite"
    />
  </div>
</template>

<script>
import { RULE_TYPE } from '@/constants'
export default {
  name: 'RuleComposite',
  props: {
    ruleReference: {
      required: true,
      type: String,
    },
    rules: {
      required: true,
      type: Array,
    },
  },
  data () {
    return {
      ruleType: RULE_TYPE,
    }
  },
}
</script>
